import { useEffect } from 'react'
import { useLocation } from '@reach/router'
import CONSTANTS from 'utils/systemsConstants'

export const useHideBot = () => {
  const location = useLocation()
  const bot = document.getElementById('blip-chat-container')
  const { DENIED_PAGES } = CONSTANTS

  useEffect(() => {
    if (bot) {
      if (DENIED_PAGES.includes(location.pathname)) {
        bot.style.display = 'none'
      } else {
        bot.style.display = ''
      }
    }
  }, [location]) //eslint-disable-line
}
